export default __webpack_public_path__ + "img/eKpMVFEt.7bdc41e9.svg";